import { MobileAppRequest } from './mobile-app-request.model';

// tslint:disable: variable-name
export class VerifyEmailAddressRequest {
  EmailAddress: string;
  Amount: number;
  RequestHeader: MobileAppRequest;

  constructor() {
    this.RequestHeader = new MobileAppRequest();
  }
}
